var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwipeRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1634 19.9212C10.1445 20.1931 11.18 19.7477 11.6853 18.8382L13.7255 15.1675C14.2999 14.1342 14.0204 12.8188 13.0802 12.1278L10.7851 10.4438C10.3277 10.1072 10.1198 9.51278 10.265 8.9521L10.9856 6.17401C11.2225 5.26171 10.6988 4.32411 9.81581 4.08032C8.93277 3.83561 8.02524 4.37661 7.78836 5.28891L5.94787 12.3865C5.91883 12.4981 5.76727 12.5019 5.73278 12.3922L5.47141 11.5624C5.06212 10.26 3.65362 9.60842 2.44021 10.1588L2.33403 10.2075C2.18701 10.2741 2.10624 10.4382 2.14072 10.6004L3.52562 17.0689C3.70622 17.9128 4.32606 18.5822 5.13287 18.8054L9.1634 19.9212Z",
    fill: "#3FCA7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.357 1.61645C17.7554 1.66427 18.0412 2.03557 17.995 2.44717L17.6719 5.33399C17.5784 6.17128 16.8252 6.75728 16.0202 6.61852L13.2459 6.14127C12.8502 6.07377 12.5834 5.68748 12.6488 5.27866C12.715 4.86987 13.0889 4.5942 13.4846 4.66172L16.2326 5.13428L16.553 2.27555C16.5983 1.86395 16.9586 1.56864 17.357 1.61645Z",
    fill: "#3FCA7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.26134 4.77217C4.03042 -1.52954 12.8761 -1.60442 16.7458 4.63246C16.9627 4.98125 16.8638 5.44537 16.5262 5.66852C16.1886 5.89261 15.7394 5.79041 15.5234 5.44162C12.2308 0.134836 4.70378 0.198443 1.49647 5.56164L1.344 5.81667C1.13255 6.16826 0.685141 6.27798 0.344802 6.06044C0.00355648 5.84197 -0.102618 5.37974 0.108848 5.02719L0.26134 4.77217Z",
    fill: "#3FCA7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwipeRight);
export default __webpack_public_path__ + "static/media/swipe-right.ffdbf64ff726f92eddded59fd47eb251.svg";
export { ForwardRef as ReactComponent };